import { RJSFSchema } from "@rjsf/utils";

import { getRanaWidgetFromProperty } from "@/features/project-process-run-form";

export const getAcceptedDataTypes = (schema: RJSFSchema) => {
  const allSchemas = [schema, ...(schema.anyOf ?? []), ...(schema.oneOf ?? [])];

  const widgets = allSchemas
    .map((property) => getRanaWidgetFromProperty(property, "file_picker"))
    .filter((w): w is NonNullable<typeof w> => !!w);

  const acceptedDataTypes = new Set<string>();
  const acceptedFeatureTypes = new Set<string>();

  for (const widget of widgets) {
    widget.data_type_filter?.forEach((type) => acceptedDataTypes.add(type));
    widget.meta_filters.feature_type_definition?.forEach((type) => acceptedFeatureTypes.add(type));
  }

  return {
    acceptedDataTypes: [...acceptedDataTypes],
    acceptedFeatureTypes: [...acceptedFeatureTypes],
  };
};
